import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  useMediaQuery,
  InputAdornment,
  OutlinedInput,
  TextField,
  Typography,
  useTheme,
  Skeleton,
  Dialog,
  Chip,
  Avatar,
  Stack,
  Divider,
  CardContent,
  CardActions,
  CardHeader,
  Tooltip,
} from "@mui/material";
import { useFormik } from "formik";
import {
  useGetMeetingHolidayQuery,
  useCreateTaskNoteMutation,
  useGetTaskHistoryRecordQuery,
  useDoneTaskMutation,
  useDeleteTaskMutation,
  useGetTaskWithoutDateQuery,
  useGetUserQuery,
  useGetAllHolydaysArrayQuery,
  useGetTaskQuery,
  useGetUserInfoOnyQuery,
  useGetCustomerQuery,
  useGetTeamQuery,
  useGetAllTaskSubjectQuery,
  useGetAllPolicyGroupByQuery,
  useGetTaskCategoryQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  IMeetingCategory,
  IMeetingHoliday,
  ITeam,
  ITasks,
  IUserInfo,
  IPolicy,
  ICustomer,
  IMeetingCategory2,
  IUserAdmin,
  IMeetingHistory,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { Badge } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import DatePicker, { DateObject } from "react-multi-date-picker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import GroupIcon from "@mui/icons-material/Group";
import { BASENAME } from "../../../config/index";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { green, red } from "@mui/material/colors";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import AlertPopup from "../../../Components/Delete/Done";
import RescheduleMeeting from "../Edit/rescheduleMeeting";
import NewPopUpDepartment from "../Edit/editMeetingAll";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReactQuill from "react-quill";
import SendIcon from "@mui/icons-material/Send";

interface HolidayFormValues {
  holidays: DateObject[];
  note: string;
}

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "meeting_Date":
      return "Schedule Date";
    case "meeting_time":
      return "Schedule Time";
    case "categoryId":
      return "Meeting Category";
    case "reminderBeforHours":
      return "Remind Before";
    case "emailReminder":
      return "Email Reminder";
    case "smsReminder":
      return "SMS Reminder";
    case "adminReminder":
      return "Admin Reminder";
    case "createNotification":
      return "Email notification on create";
    case "staffIds":
      return "Staff";
    case "clientId":
      return "Client";
    case "policyId":
      return "Policy";
    case "subject":
      return "Subject";
    case "start_Date":
      return "Start Date";
    case "end_Date":
      return "End Date";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { id: meetingId } = useParams<{ id: string }>();

  const { showErrorMessage, showMessage } = useNotifier();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [selectedCoursing, setSelectedCoursing] = useState<ITasks | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState<ITasks | null>(null);
  const [openDialogMeeting, setOpenDialogMeeting] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ITasks | null>(null);
  const [openDoneMeeting, setOpenDoneMeeting] = useState(false);
  const [meetingToDone, setMeetingToDone] = useState<ITasks | null>(null);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [newDepartment, { isLoading: meetingUPIsLoading }] =
    useCreateTaskNoteMutation();

  const { data: userData } = useGetUserQuery();
  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetTaskWithoutDateQuery({
    searchText: "",
    staffId: userId || "",
    clientId: "",
    id: String(meetingId),
    fromDate: null,
    toDate: null,
    categoryId: "",
    multi_final_status_filter: [],

  });

  const {
    data: meetingHistoryRecordData,
    isLoading: meetingHistoryRecordIsLaoding,
  } = useGetTaskHistoryRecordQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: String(meetingId),
      meeting_Date: "",
    },
    {
      pollingInterval: 2000,
    }
  );

  const { data: holydaysData, isLoading: holidaysIsLoading } =
    useGetAllHolydaysArrayQuery({
      searchText: "",
      id: "",
    });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetTaskQuery({
    searchText: "",
    staffId: userId || "",
    clientId: "",
    id: "",
    meeting_Date: "",
  });
  const { data: clientData, isLoading: cilentIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: staffData, isLoading: staffIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: meetingAllData, isLoading: meetingAllIsLoading } =
    useGetAllTaskSubjectQuery({
      searchText: "",
      id: "",
    });

  const {
    data: policyData,
    isLoading: policyIsLoading,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: "",
  });

  const {
    data: getAllMeetingCategoryData,
    isLoading: meetingCategoryIsLoading,
  } = useGetTaskCategoryQuery({
    searchText: "",
  });

  const { data: policyAllData, isLoading: policyAllIsLoading } =
    useGetAllPolicyGroupByQuery({
      searchText: "",
      id: "",
      policyCustomerId: "",
    });

  const { data: userAllData, isLoading: userIsLoading } =
    useGetUserInfoOnyQuery({
      searchText: "",
    });

  const fristIndexMeeting = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ITasks;
    }
    return null;
  }, [data]);

  const meetingHistoryRecord: ITasks[] = Array.isArray(
    meetingHistoryRecordData?.data
  )
    ? (meetingHistoryRecordData?.data as ITasks[])
    : [];

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as ICustomer[];
  }, [clientData?.data]);

  const staffList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const policyList = useMemo(() => {
    return (policyData?.data ?? []) as IPolicy[];
  }, [policyData?.data]);

  const meetingCategoryList = useMemo(() => {
    return (getAllMeetingCategoryData?.data ?? []) as IMeetingCategory2[];
  }, [getAllMeetingCategoryData?.data]);

  const policyAllList = useMemo(() => {
    return (policyAllData?.data ?? []) as IPolicy[];
  }, [policyAllData?.data]);

  const userList = useMemo(() => {
    return userAllData?.data as IUserAdmin[];
  }, [userAllData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(staffList)) return [];
    return staffList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [staffList]);

  const policyOptions = useMemo(() => {
    if (!Array.isArray(policyList)) return [];
    return policyList.map((cust) => ({
      label: `${cust.policyNumber}`,
      value: cust.id,
    }));
  }, [policyList]);

  const meetingCategoryOptions = useMemo(() => {
    if (!Array.isArray(meetingCategoryList)) return [];
    return meetingCategoryList.map((cust) => ({
      label: `${cust.name}`,
      value: cust.id,
    }));
  }, [meetingCategoryList]);

  const clientMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    staffList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [staffList]);

  const meetingCategoryMap = useMemo(() => {
    const map = new Map();
    meetingCategoryList?.forEach((category) => {
      map.set(category.id, category.name);
    });
    return map;
  }, [meetingCategoryList]);

  const allPolicyMap = useMemo(() => {
    const map = new Map();
    policyAllList?.forEach((category) => {
      map.set(category.id, category.policyNumber);
    });
    return map;
  }, [policyAllList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.staff}`);
    });
    return map;
  }, [userList]);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // If scrolled less than 100px from bottom, hide arrow; else show
    if (scrollHeight - scrollTop - clientHeight > 100) {
      setShowScrollDown(true);
    } else {
      setShowScrollDown(false);
    }
  };

  // Scroll to bottom function
  const scrollToBottom = () => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [meetingHistoryRecord]);

  const handleOpenDialog = (coursing: ITasks) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDialogMeeting = (coursing: ITasks) => {
    setSelectedMeeting(coursing);
    setOpenDialogMeeting(true);
  };

  const handleCloseDialogMeeting = () => {
    setSelectedMeeting(null);
    setOpenDialogMeeting(false);
  };

  const handleOpenDeletePopup = (coursing: ITasks) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleOpenDonePopup = (coursing: ITasks) => {
    setMeetingToDone(coursing);
    setOpenDoneMeeting(true);
  };

  const handleCloseDonePopup = () => {
    setMeetingToDone(null);
    setOpenDoneMeeting(false);
  };

  const formikMessageEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: String(meetingId),
      note: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(meetingId),
          note: values.note,
        };
        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          // showMessage(addCompanyResponse.message);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValidMessageEdit = useMemo(() => {
    return formikMessageEdit.values.note === "" ||
      formikMessageEdit.values.id === ""
      ? false
      : true;
  }, [formikMessageEdit.values]);

  const [deleteCategory] = useDeleteTaskMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
        navigate(`/client/task`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting");
    }
  };

  const [deleteDoneMeeting] = useDoneTaskMutation();
  const handleDeleteDoneMeeting = async (id: string) => {
    try {
      const response = await deleteDoneMeeting(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDoneMeeting(false);
        navigate(`/client/task`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting done");
    }
  };

  const renderReminderChip = (label: string, enabled?: boolean) => (
    <Chip
      label={label}
      color={enabled ? "success" : "error"}
      icon={enabled ? <CheckIcon /> : <CancelIcon />}
      variant="outlined"
      size="small"
      sx={{
        borderColor: enabled ? green[600] : red[400],
        color: enabled ? green[800] : red[600],
        m: "4px",
      }}
    />
  );

  // const getChangedFields = (current: ITasks, prev: ITasks | null) => {
  //   if (!prev) return [];

  //   const fieldsToCheck: (keyof ITasks)[] = [
  //     "meeting_Date",
  //     "meeting_time",
  //     "categoryId",
  //     "reminderBeforHours",
  //     "emailReminder",
  //     "smsReminder",
  //     "adminReminder",
  //     "createNotification",
  //     "staffId",
  //     "clientId",
  //     "subject",
  //   ];

  //   return fieldsToCheck
  //     .map((field) => {
  //       if (current[field] !== prev[field]) {
  //         return {
  //           field,
  //           oldValue: prev[field],
  //           newValue: current[field],
  //         };
  //       }
  //       return null;
  //     })
  //     .filter(Boolean) as {
  //     field: keyof ITasks;
  //     oldValue: any;
  //     newValue: any;
  //   }[];
  // };

  const getChangedFields = (
    current: ITasks,
    prev: ITasks | null,
    maps: {
      meetingCategoryMap: Map<number, string>;
      staffMap: Map<number, string>;
      clientMap: Map<number, string>;
      policyMap: Map<number, string>;
    }
  ) => {
    if (!prev) return [];

    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (field: keyof ITasks, value: any): string => {
      if (value === undefined || value === null) return "-";

      switch (field) {
        case "start_Date":
          return dayjs(value).format("MMM D, YYYY");
        case "end_Date":
          return dayjs(value).format("MMM D, YYYY");
        case "categoryId":
          return (
            maps.meetingCategoryMap.get(Number(value)) || `Category #${value}`
          );
        case "staffId":
          return maps.staffMap.get(Number(value)) || `Staff #${value}`;
        case "clientId":
          return maps.clientMap.get(Number(value)) || `Client #${value}`;
        case "policyId":
          return maps.policyMap.get(Number(value)) || `Policy #${value}`;
        case "emailReminder":
        case "smsReminder":
        case "adminReminder":
        case "createNotification":
          return value ? "On" : "Off";
        case "reminderBeforHours":
          return `${value} Hours`;
        case "note":
          return `${value}`;
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof ITasks)[] = [
      "start_Date",
      "end_Date",
      "categoryId",
      "reminderBeforHours",
      "emailReminder",
      "smsReminder",
      "adminReminder",
      "createNotification",
      "staffId",
      "clientId",
      "policyId",
      "subject",
      "note",
    ];

    return fieldsToCheck
      .map((field) => {
        if (current[field] !== prev[field]) {
          return {
            field,
            oldValue: formatFieldValue(field, prev[field]),
            newValue: formatFieldValue(field, current[field]),
          };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof ITasks;
      oldValue: string;
      newValue: string;
    }[];
  };

  if (meetingCategoryIsLoading || userIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Card
            elevation={3}
            sx={{
              height: "100%",
              borderRadius: setCardBRadius,
              // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
              // backgroundColor: theme.palette.cardAdd.bgColor,
              p: 1,
              // minHeight: "100vh",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 3,
                    // background: "linear-gradient(to bottom, #f9f9f9, #fff)",
                    // border: "1px solid #e0e0e0",
                  }}
                >
                  <CardHeader
                    avatar={
                      <Avatar
                        sx={{
                          bgcolor:
                            fristIndexMeeting?.meeting_category_color ||
                            "primary.main",
                          width: 60,
                          height: 60,
                          fontSize: 24,
                          fontWeight: "bold",
                        }}
                      >
                        {fristIndexMeeting?.subject
                          ?.charAt(0)
                          .toUpperCase() || <GroupIcon />}
                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings">
                        {/* <MoreVertIcon /> */}
                      </IconButton>
                    }
                    title={
                      <Typography
                        className={classes.mL1Heading}
                        fontWeight={700}
                      >
                        {fristIndexMeeting?.subject || "Untitled Meeting"}
                      </Typography>
                    }
                    subheader={
                      (fristIndexMeeting?.categoryId ||
                        fristIndexMeeting?.start_Date ||
                        fristIndexMeeting?.meeting_time) && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            mt: 0.5,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          {[
                            fristIndexMeeting?.categoryId
                              ? meetingCategoryMap.get(
                                  fristIndexMeeting.categoryId
                                )
                              : null,
                            fristIndexMeeting?.start_Date
                              ? ` ${dayjs(fristIndexMeeting.start_Date).format(
                                  "MMM D, YYYY"
                                )}`
                              : null,
                            fristIndexMeeting?.meeting_time
                              ? ` ${formatTime(fristIndexMeeting.meeting_time)}`
                              : null,
                          ]
                            .filter(Boolean)
                            .map((text, idx, arr) => (
                              <span key={idx}>
                                {text}
                                {idx < arr.length - 1 && " | "}
                              </span>
                            ))}
                        </Typography>
                      )
                    }
                    sx={{
                      // background: `linear-gradient(to bottom, ${theme.palette.cardAdd.thirdBgColor}, #fff)`,
                      // borderBottom: `5px solid ${theme.palette.primary.main}`,
                      background: theme.palette.cardAdd.thirdBgColor,
                    }}
                  />

                  <CardContent>
                    {/* <Grid container alignItems="center" spacing={2}>
                      <Grid item>
                        <Avatar
                          sx={{
                            bgcolor:
                              fristIndexMeeting?.meeting_category_color ||
                              "primary.main",
                            width: 60,
                            height: 60,
                            fontSize: 24,
                            fontWeight: "bold",
                          }}
                        >
                          {fristIndexMeeting?.subject
                            ?.charAt(0)
                            .toUpperCase() || <GroupIcon />}
                        </Avatar>
                      </Grid>
                      <Grid item xs>
                        <Typography
                          className={classes.mL1Heading}
                          fontWeight={700}
                        >
                          {fristIndexMeeting?.subject || "Untitled Meeting"}
                        </Typography>
                        {(fristIndexMeeting?.categoryId ||
                          fristIndexMeeting?.meeting_Date ||
                          fristIndexMeeting?.meeting_time) && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              mt: 0.5,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            {[
                              fristIndexMeeting?.categoryId
                                ? meetingCategoryMap.get(
                                    fristIndexMeeting.categoryId
                                  )
                                : null,
                              fristIndexMeeting?.meeting_Date
                                ? ` ${dayjs(
                                    fristIndexMeeting.meeting_Date
                                  ).format("MMM D, YYYY")}`
                                : null,
                              fristIndexMeeting?.meeting_time
                                ? ` ${formatTime(
                                    fristIndexMeeting.meeting_time
                                  )}`
                                : null,
                            ]
                              .filter(Boolean)
                              .map((text, idx, arr) => (
                                <span key={idx}>
                                  {text}
                                  {idx < arr.length - 1 && " | "}
                                </span>
                              ))}
                          </Typography>
                        )}
                      </Grid>
                    </Grid> */}

                    <Grid
                      item
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={1}>
                        {/* Staff Section */}
                        {fristIndexMeeting?.staffId && (
                          <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center" spacing={"1px"}>
                              <Grid item xs={12}>
                                <Typography
                                  color="text.secondary"
                                  fontWeight={600}
                                >
                                  Staff
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Link
                                  to={`/team-history/${fristIndexMeeting.staffId}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography
                                    color="primary"
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {staffMap.get(fristIndexMeeting.staffId) ||
                                      ""}
                                    <FontAwesomeIcon
                                      icon={faUser}
                                      style={{
                                        // color: "#757575",
                                        marginLeft: 8,
                                      }}
                                    />
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* Client & Policy Section */}
                        {(fristIndexMeeting?.clientId ||
                          fristIndexMeeting?.policyId) && (
                          <Grid item xs={12} sm={6}>
                            <Grid container spacing={"1px"}>
                              <Grid item xs={12}>
                                <Typography
                                  color="text.secondary"
                                  fontWeight={600}
                                >
                                  Client & Policy
                                </Typography>
                              </Grid>

                              {/* Client */}
                              {fristIndexMeeting?.clientId && (
                                <>
                                  <Grid item>
                                    <Link
                                      to={`/profile/customer/${fristIndexMeeting.clientId}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Typography
                                        sx={{
                                          cursor: "pointer",
                                          color: "primary.main",
                                        }}
                                      >
                                        {clientMap.get(
                                          fristIndexMeeting.clientId
                                        ) || ""}
                                        <FontAwesomeIcon
                                          icon={faUser}
                                          style={{
                                            // color: "#757575",
                                            marginLeft: 8,
                                          }}
                                        />
                                      </Typography>
                                    </Link>
                                  </Grid>
                                </>
                              )}

                              {/* Policy */}
                              {fristIndexMeeting?.policyId && (
                                <Grid item xs={12}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <Link
                                        to={`/customer/${
                                          fristIndexMeeting.clientId
                                        }/policy/${allPolicyMap.get(
                                          Number(fristIndexMeeting.policyId)
                                        )}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography
                                          sx={{
                                            cursor: "pointer",
                                            color: "primary.main",
                                          }}
                                        >
                                          {allPolicyMap.get(
                                            Number(fristIndexMeeting.policyId)
                                          ) || ""}
                                          <FontAwesomeIcon
                                            icon={faLink}
                                            style={{
                                              // color: "#757575",
                                              marginLeft: 8,
                                            }}
                                          />
                                        </Typography>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>

                    {/* <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={2}>
                        {fristIndexMeeting?.staffId && (
                          <Grid item xs={12} sm={6}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <PersonIcon fontSize="small" color="action" />
                              <Typography
                                variant="body2"
                                color="primary"
                                sx={{
                                  cursor: "pointer",
                                  "&:hover": { textDecoration: "underline" },
                                }}
                                onClick={() =>
                                  navigate(
                                    `/main/item/view/${fristIndexMeeting.staffId}`
                                  )
                                }
                              >
                                {staffMap.get(fristIndexMeeting.staffId) ||
                                  `Staff #${fristIndexMeeting.staffId}`}
                              </Typography>
                            </Box>
                          </Grid>
                        )}

                        {fristIndexMeeting?.clientId && (
                          <Grid item xs={12} sm={6}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <AccountCircleIcon
                                fontSize="small"
                                color="action"
                              />
                              <Typography
                                variant="body2"
                                sx={{
                                  cursor: "pointer",
                                  color: "primary.main",
                                }}
                                onClick={() =>
                                  window.open(
                                    `${BASENAME}/profile/customer/${fristIndexMeeting.clientId}`,
                                    "_blank"
                                  )
                                }
                              >
                                {clientMap.get(fristIndexMeeting.clientId) ||
                                  `Client #${fristIndexMeeting.clientId}`}
                              </Typography>
                            </Box>
                          </Grid>
                        )}

                        {fristIndexMeeting?.policyId && (
                          <Grid item xs={12}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <PolicyIcon fontSize="small" color="action" />
                              <Typography
                                variant="body2"
                                sx={{
                                  cursor: "pointer",
                                  color: "primary.main",
                                }}
                                onClick={() =>
                                  window.open(
                                    `${BASENAME}/customer/${fristIndexMeeting.policyId}/policy/${fristIndexMeeting.policyId}`,
                                    "_blank"
                                  )
                                }
                              >
                                {allPolicyMap.get(
                                  Number(fristIndexMeeting.policyId)
                                ) || `Policy #${fristIndexMeeting.policyId}`}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Grid> */}
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box
                            sx={{
                              borderBottom: { xs: "1px solid", sm: "none" },
                              borderColor: "divider",
                              pb: { xs: 2, sm: 0 },
                              mb: { xs: 2, sm: 0 },
                            }}
                          >
                            {fristIndexMeeting?.created_at && (
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography
                                  // variant="caption"
                                  color="text.secondary"
                                >
                                  📅 Created On:
                                </Typography>
                                <Typography variant="body2">
                                  {dayjs(fristIndexMeeting.created_at).format(
                                    "MMM D, YYYY"
                                  )}
                                </Typography>
                              </Box>
                            )}

                            {fristIndexMeeting?.created_by && (
                              <Box
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Typography
                                  // variant="caption"
                                  color="text.secondary"
                                >
                                  🧑 Created By:
                                </Typography>
                                <Typography variant="body2">
                                  {userMap.get(fristIndexMeeting.created_by) ||
                                    "-"}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            color="text.secondary"
                            fontWeight={600}
                            gutterBottom
                          >
                            🔔 Reminders
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {renderReminderChip(
                            "Email Reminder",
                            fristIndexMeeting?.emailReminder
                          )}
                          {renderReminderChip(
                            "SMS Reminder",
                            fristIndexMeeting?.smsReminder
                          )}
                          {renderReminderChip(
                            "Admin Reminder",
                            fristIndexMeeting?.adminReminder
                          )}
                          {renderReminderChip(
                            "Notify on Creation",
                            fristIndexMeeting?.createNotification
                          )}
                          {fristIndexMeeting?.reminderBeforHours && (
                            <Typography
                              color="text.secondary"
                              gutterBottom
                              pt={1}
                            >
                              🔘{" "}
                              {fristIndexMeeting?.reminderBeforHours
                                ? `Remind Before ${fristIndexMeeting.reminderBeforHours}`
                                : ""}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                  {fristIndexMeeting?.status !== "done" &&
                    fristIndexMeeting?.status !== "cancel" && (
                      <CardActions
                        sx={{ background: theme.palette.cardAdd.thirdBgColor }}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          mt={2}
                          mb={2}
                        >
                          {fristIndexMeeting && (
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                            >
                              <Grid item>
                                <Button
                                  className={classes.mLButtonUpdate}
                                  onClick={() =>
                                    handleOpenDialog(fristIndexMeeting)
                                  }
                                >
                                  Edit
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  className={classes.mLButtonUpdate}
                                  onClick={() =>
                                    handleOpenDialogMeeting(fristIndexMeeting)
                                  }
                                >
                                  Reschedule
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  className={classes.mL12ButtonView}
                                  onClick={() =>
                                    handleOpenDonePopup(fristIndexMeeting)
                                  }
                                >
                                  Complete
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  className={classes.mL12ButtonDelate}
                                  onClick={() =>
                                    handleOpenDeletePopup(fristIndexMeeting)
                                  }
                                >
                                  Cancel
                                </Button>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </CardActions>
                    )}
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Card
            elevation={2}
            sx={{
              height: "100%",
              // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
              p: 1,
              borderRadius: setCardBRadius,
              minHeight: "70vh",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 3,
                    // background: "linear-gradient(to bottom, #f9f9f9, #fff)",
                    // border: "1px solid #e0e0e0",
                  }}
                >
                  <CardContent
                    sx={
                      {
                        // minHeight: "80vh",
                      }
                    }
                  >
                    {" "}
                    <Box
                      sx={{
                        position: "relative",
                        maxHeight: "60vh",
                        minHeight: "60vh",
                        overflowY: "auto",
                        padding: "8px",
                        "&::-webkit-scrollbar": {
                          width: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#eeeeee",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#cccccc",
                          borderRadius: "10px",
                        },
                      }}
                      ref={containerRef}
                      onScroll={handleScroll}
                    >
                      <Grid container spacing={2} direction="column">
                        {meetingHistoryRecord.length ? (
                          meetingHistoryRecord.map((msg, index) => {
                            const isMine = false;

                            const prev =
                              index > 0
                                ? meetingHistoryRecord[index - 1]
                                : null;
                            // const changes =
                            //   msg.status === "updated"
                            //     ? getChangedFields(msg, prev)
                            //     : null;

                            const changes =
                              msg.status === "updated"
                                ? getChangedFields(msg, prev, {
                                    meetingCategoryMap,
                                    staffMap,
                                    clientMap,
                                    policyMap: allPolicyMap,
                                  })
                                : null;

                            return (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  key={msg.id}
                                  container
                                  justifyContent={
                                    isMine ? "flex-end" : "flex-start"
                                  }
                                >
                                  {msg.status === "updatedNote"  || (msg.status === "created")? (
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        maxWidth: "80%",
                                        padding: 2,
                                        backgroundColor: isMine
                                          ? "#DCF8C6"
                                          : "#fff",
                                        borderRadius: 3,
                                        boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                        border: "1px solid #e1dfdf",
                                        position: "relative",
                                        alignSelf: isMine
                                          ? "flex-end"
                                          : "flex-start",
                                        // "&::before": {
                                        //   content: '""',
                                        //   display: "block",
                                        //   position: "absolute",
                                        //   top: 12,
                                        //   [isMine ? "right" : "left"]: -6,
                                        //   width: 10,
                                        //   height: 10,
                                        //   // borderLeft: `2px solid ${fristIndexMeeting?.meeting_category_color || theme.palette.primary.main}`,
                                        //   // borderLeft: "4px solid #DCF8C6",
                                        //   // borderBottom: "4px solid #DCF8C6",
                                        //   backgroundColor: isMine
                                        //     ? "#DCF8C6"
                                        //     : "#fff",
                                        //   // transform: isMine
                                        //   //   ? "rotate(45deg)"
                                        //   //   : "rotate(45deg)",
                                        //   zIndex: 0,
                                        // },
                                      }}
                                    >
                                      {isMine && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            top: 4,
                                            right: 4,
                                            transition: "opacity 0.2s",
                                          }}
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={(e) => {
                                              setAnchorEl(e.currentTarget);
                                              setCoursingToDelete(msg);
                                            }}
                                          >
                                            <MoreVertIcon fontSize="small" />
                                          </IconButton>
                                        </Box>
                                      )}

                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontWeight: 600,
                                          color: "primary.main",
                                          marginBottom: 1,
                                        }}
                                      >
                                        {userMap.get(msg.updated_by) || ""}
                                      </Typography>

                                      <Typography
                                        sx={{
                                          color: "#333",
                                          fontSize: "14px",
                                          lineHeight: "1.6",
                                          marginTop: !isMine ? 0.5 : 0,
                                        }}
                                      >
                                        {msg.note}
                                      </Typography>
                                      <Grid
                                        item
                                        sx={{
                                          textAlign: "right",
                                          marginTop: 1,
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          sx={{ color: "primary.main" }}
                                        >
                                          {dayjs(msg.updated_at).format(
                                            "MMM D, YYYY h:mm A"
                                          )}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  ) : msg.status === "updated" &&
                                    changes?.length ? (
                                    <Grid
                                      container
                                      direction="column"
                                      alignItems="center"
                                      spacing={1}
                                      py={3}
                                    >
                                      <Typography
                                        // variant="subtitle2"
                                        color="primary.main"
                                        fontSize={"12px"}
                                        fontWeight={700}
                                      >
                                        {userMap.get(msg.updated_by) || ""} made
                                        changes:
                                      </Typography>
                                      {changes.map((change, idx) => (
                                        <Typography
                                          key={idx}
                                          fontSize={"12px"}
                                          color="text.secondary"
                                          lineHeight={1.7}
                                        >
                                          {variantPropName(change.field)}{" "}
                                          changed from{" "}
                                          <s>{String(change.oldValue)}</s> ➜{" "}
                                          {String(change.newValue)}
                                        </Typography>
                                      ))}
                                    </Grid>
                                  ) : msg.status === "done" ||
                                    msg.status === "cancel" ? (
                                    <Grid
                                      container
                                      direction="column"
                                      alignItems="center"
                                      spacing={1}
                                      py={3}
                                    >
                                      <Typography
                                        color={
                                          msg.status === "done"
                                            ? "success.main"
                                            : "error.main"
                                        }
                                        fontSize="12px"
                                        fontWeight={700}
                                      >
                                        {msg.status === "done"
                                          ? `Task Completed by ${
                                              userMap.get(msg.updated_by) ||
                                              "Unknown User"
                                            }`
                                          : `Task Cancelled by ${
                                              userMap.get(msg.updated_by) ||
                                              "Unknown User"
                                            }`}
                                      </Typography>

                                      {changes?.length ? (
                                        changes.map((change, idx) => (
                                          <Typography
                                            key={idx}
                                            fontSize="12px"
                                            color="text.secondary"
                                            lineHeight={1.7}
                                          >
                                            {variantPropName(change.field)}{" "}
                                            changed from{" "}
                                            <s>{String(change.oldValue)}</s> ➜{" "}
                                            {String(change.newValue)}
                                          </Typography>
                                        ))
                                      ) : (
                                        <Typography
                                          fontSize="12px"
                                          color="text.secondary"
                                        >
                                          {msg.status === "done"
                                            ? "No further changes after completion."
                                            : "No changes were made before cancellation."}
                                        </Typography>
                                      )}
                                    </Grid>
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    ></Typography>
                                  )}
                                </Grid>
                              </>
                            );
                          })
                        ) : (
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                            ></Typography>
                          </Grid>
                        )}
                      </Grid>
                      {showScrollDown && (
                        <IconButton
                          onClick={scrollToBottom}
                          size="small"
                          sx={{
                            position: "sticky",
                            bottom: 8,
                            left: "50%",
                            transform: "translateX(-50%)",
                            bgcolor: "#1976d2",
                            color: "#fff",
                            "&:hover": { bgcolor: "#1565c0" },
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                          }}
                          aria-label="Scroll to last message"
                        >
                          <ArrowDownwardIcon />
                        </IconButton>
                      )}
                    </Box>
                  </CardContent>
                  {fristIndexMeeting?.status !== "done" &&
                    fristIndexMeeting?.status !== "cancel" && (
                      <CardActions
                        sx={{ background: theme.palette.cardAdd.thirdBgColor }}
                      >
                        <form
                          onSubmit={formikMessageEdit.handleSubmit}
                          style={{ width: "100%" }}
                        >
                          <Grid container spacing={2}>
                            {/* Message Input */}
                            <Grid item xs={12}>
                              <Card
                                variant="outlined"
                                sx={{
                                  padding: 1,
                                  backgroundColor: "#fff",
                                  mt: 2,
                                }}
                              >
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <TextField
                                        placeholder="Update .."
                                        size="small"
                                        multiline
                                        rows={5}
                                        {...formikMessageEdit.getFieldProps(
                                          "note"
                                        )}
                                        className={classes.discriptionTextField}
                                        InputProps={{
                                          sx: {
                                            fontSize: 14,
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            fontSize: 14,
                                          },
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>

                            {/* Send Button Aligned Right */}
                            <Grid item xs={6}>
                              <Tooltip title="Clear">
                                <IconButton
                                  onClick={() => {
                                    formikMessageEdit.resetForm();
                                  }}
                                  sx={{
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    color: "primary.main",
                                    borderRadius: "4px",
                                    padding: "10px",
                                    transition: "0.3s",
                                    fontSize: "15px",
                                    gap: 1,
                                  }}
                                >
                                  <CloseIcon /> Clear
                                </IconButton>
                              </Tooltip>
                            </Grid>

                            <Grid item xs={6}>
                              <Tooltip title="Send Message">
                                <IconButton
                                  type="submit"
                                  disabled={
                                    !formValidMessageEdit || meetingUPIsLoading
                                  }
                                  sx={{
                                    width: "100%",
                                    color: "white",
                                    fontSize: "15px",
                                    gap: 1,
                                    // textTransform: "uppercase",
                                    backgroundColor: "primary.main",
                                    borderRadius: "4px",
                                    padding: "10px",
                                    transition: "0.3s",
                                    "&:hover": {
                                      backgroundColor: "primary.dark",
                                    },
                                  }}
                                >
                                  Send <SendIcon />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </form>
                      </CardActions>
                    )}
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {selectedCoursing && (
          <NewPopUpDepartment
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}

        {selectedMeeting && (
          <RescheduleMeeting
            openModel={openDialogMeeting}
            handleCloseDialog={handleCloseDialogMeeting}
            data={selectedMeeting}
          />
        )}

        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Cancel Task Confirmation"
            content={`Are you sure you want to cancel the task "${coursingToDelete.subject}"? This action cannot be undone.`}
          />
        )}

        {meetingToDone && (
          <AlertPopup
            open={openDoneMeeting}
            handleCloseDelete={handleCloseDonePopup}
            onConfirm={async () => {
              await handleDeleteDoneMeeting(meetingToDone.id.toString());
            }}
            title="Mark Task as completed"
            content={`Are you sure you want to complete the task "${meetingToDone.subject}"? This will mark it as done.`}
          />
        )}
      </Grid>
    </div>
  );
};

export default Index;
